import React from 'react';
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';
import {
  StyledAlreadySentDialog,
  AlreadySentDialogTitle,
  AlreadySentDialogContent,
  AlreadySentHighlight,
  AlreadySentDialogActions,
  AlreadySentOkButton,
} from './AlreadySentInquiryModal.styled';

export default function AlreadySentInquiryModal({
  open,
  onClose,
  businessName,
  serviceName,
}) {
  const businessLabel = (businessName || '').trim() || 'this business';
  const serviceLabel = (serviceName || '').trim() || 'this service';

  return (
    <StyledAlreadySentDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="already-sent-inquiry-title"
    >
      <AlreadySentDialogTitle id="already-sent-inquiry-title">
        <span className="already-sent-icon-wrap" aria-hidden>
          <MarkEmailReadRoundedIcon className="already-sent-icon" />
        </span>
        Inquiry already sent
      </AlreadySentDialogTitle>

      <AlreadySentDialogContent>
        <AlreadySentHighlight>
          You already sent an inquiry to <strong>{businessLabel}</strong> for{' '}
          <strong>{serviceLabel}</strong>.
        </AlreadySentHighlight>
        <p style={{ margin: 0 }}>
          The business has your request and will reach out when they can. You do not need to
          send another message for the same service.
        </p>
      </AlreadySentDialogContent>

      <AlreadySentDialogActions>
        <AlreadySentOkButton variant="contained" disableElevation onClick={onClose}>
          Got it
        </AlreadySentOkButton>
      </AlreadySentDialogActions>
    </StyledAlreadySentDialog>
  );
}
